import React from 'react'
import { graphql } from 'gatsby'
import DownloadAssets, {
  DownloadAssetsContent,
} from 'src/components/organisms/general/downloadAssets'

type Props = {
  slice: any
}

const DownloadAssetsSlice = ({ slice }: Props) => {
  const content: DownloadAssetsContent = {
    label: slice.primary?.label,
    files:
      slice.items?.map((item: any) => ({
        fileLabel: item.file_label,
        fileImage: item.file_image,
        file: item.file,
      })) ?? [],
  }

  return <DownloadAssets content={content} />
}

export default DownloadAssetsSlice

export const DownloadAssetsFragment = graphql`
  fragment PageDataBodyDownloadAssets on PrismicPageDataBodyDownloadAssets {
    primary {
      label {
        richText
      }
    }
    items {
      file_label {
        richText
      }
      file_image {
        url
        size
      }
      file {
        url
        size
      }
    }
  }
`
